<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt" id="copy"><a id="page_ii"></a>Copyright © 2015 by Allan Abbass, MD</p>
<p class="copy">All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other noncommercial uses permitted by copyright law. For permission requests, write to the publisher, addressed “Attention: Permissions Coordinator” at the address below.</p>
<p class="copy">Seven Leaves Press<br/>4550 Belleview<br/>Kansas City, MO 64111<br/><a class="nounder" href="http://www.sevenleavespress.com" target="_blank">www.sevenleavespress.com</a></p>
<p class="copy">Ordering Information</p>
<p class="copy"><strong>Quantity sales.</strong> Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the “Special Sales Department” at the address above.</p>
<p class="copy"><strong>Orders by US trade bookstores and wholesalers.</strong> Please contact BCH: (800) 431-1579 or visit <a class="nounder" href="http://www.bookch.com" target="_blank">www.bookch.com</a> for details.</p>
<p class="copy">Printed in the United States of America</p>
<p class="copyb">Abbass, Allan.</p>
<p class="copy1">Reaching through resistance : advanced psychotherapy techniques / Allan Abbass, MD. — First edition.</p>
<p class="copy1">pages cm</p>
<p class="copy1">Includes bibliographical references and index.</p>
<p class="copy1">LCCN 2014959405</p>
<p class="copy1">ISBN 978-0-9883788-6-5 (print)</p>
<p class="copy1b">ISBN 978-0-9883788-7-2 (ebook)</p>
<p class="copy1">a. Resistance (Psychoanalysis) 1. Title.</p>
<p class="copyb">RC489.R49A23 2015              616.89’14</p>
<p class="copy">QBI15-600052</p>
<p class="copy">First Edition<br/>19 18 17 16 15   10 9 8 7 6 5 4 3 2 1</p>
<p class="copy">Cover image: Kristina Sobstad<br/>Cover design: VMC Art &amp; Design<br/>Interior design: Marin Bookworks</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?5fa1cfa9